<template>
    <div class="row">
        <!-- main title -->
        <div class="col-12">
            <div class="main__title">
                <h2>گزارش پرداختی ها</h2>
            </div>
        </div>
        <!-- end main title -->

        <!-- form -->
        <div class="col-12">

            <div class="row">
                <!-- main title -->
                <!-- end main title -->

                <!-- users -->
                <div class="col-12">
                    <Datatable
                            :items="items"
                            :fields="fields"
                            style="overflow: auto"
                            :items-per-page="20"
                            hover
                            height="300px"
                            border
                            striped
                            sorter
                            column-filter
                            pagination
                    >
                        <template #row="{item,index}">
                            <td>
                                <div class="main__table-text">{{index+1}}</div>
                            </td>
                        </template>



                        <template #user="{item,index}">
                            <td>
                                <div class="main__table-text">{{item.user.phone}}</div>
                            </td>
                        </template>

                        <template #total_price="{item,index}">
                            <td>
                                <div class="main__table-text">{{(item.total_price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</div>
                            </td>
                        </template>



                        <template #created_at="{item,index}">
                            <td>
                                <div class="main__table-text">{{get_date(item.created_at)}}</div>
                            </td>
                        </template>
                        <template #video_link="{item,index}">
                            <td>
                                <div class="main__table-text">{{item.link}}</div>
                            </td>
                        </template>
                        <template #operation="{item}">
                            <td>
                                <div class="main__table-btns">

<!--                                    <div @click="edit_item(item)" datas="#"-->
<!--                                         class="main__table-btn main__table-btn&#45;&#45;edit">-->
<!--                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">-->
<!--                                            <path d="M22,7.24a1,1,0,0,0-.29-.71L17.47,2.29A1,1,0,0,0,16.76,2a1,1,0,0,0-.71.29L13.22,5.12h0L2.29,16.05a1,1,0,0,0-.29.71V21a1,1,0,0,0,1,1H7.24A1,1,0,0,0,8,21.71L18.87,10.78h0L21.71,8a1.19,1.19,0,0,0,.22-.33,1,1,0,0,0,0-.24.7.7,0,0,0,0-.14ZM6.83,20H4V17.17l9.93-9.93,2.83,2.83ZM18.17,8.66,15.34,5.83l1.42-1.41,2.82,2.82Z"/>-->
<!--                                        </svg>-->
<!--                                    تایید کردن-->
<!--                                    </div>-->

                                </div>
                            </td>
                        </template>
                    </Datatable>

                </div>


            </div>
        </div>
        <!-- end form -->
    </div>
</template>

<script>
    import axios from "axios";
    // import {bus} from '../main';
    import Datatable from "@/views/customTable/Datatable";

    export default {
        name: 'HelloWorld',
        data() {
            return {
                items: [],
                fields: [
                    {key: 'row', label: 'ردیف'},
                    {key: 'user', label: 'کاربر'},
                  {key: 'total_price', label: 'مبلغ'},
                  {key: 'created_at', label: 'تاریخ'},

                    // {key: 'video_link', label: 'ویدئو'},
                    {key: 'operation', label: 'عملیات'}
                ],
                status_form: 0,
                name: '',
            }
        },
        components: {
            Datatable
        },
        mounted() {
            this.get_data();
        },
        methods: {
            edit_item(item) {
                this.name = item.name;
                this.status_form = item.id;
                this.insert_data()
            },
            get_data() {

                var self = this;

                var formData = new FormData();

                this.axios.post('get_all_invoice_report', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    self.items = content_data

                }).catch(function (error) {
                    console.log(error);
                });


            },
            insert_data() {

                var self = this;

                var formData = new FormData();
                var url = 'confirm_comment'
                    formData.append('id', this.status_form);

                this.axios.post(url, formData, {}).then(function (response) {

                    self.get_data()
                    self.$toast.success('ثبت با موفقیت انجام شد');

                }).catch(function (error) {
                    console.log(error);
                    self.$toast.error('خطا در ثبت اطلاعات');

                });


            },
        }
    }
</script>

